import React from 'react'
import './spin.css'

function SpinLoad(props) {
  return (
      <div className="spin">
        <img src = {process.env.PUBLIC_URL + '/images/Icone_Colorido1_TextoAzulEscuro.png'}/>
      </div>
  )
}

export default SpinLoad


    //     <div className="spin" style = {{
    //       backgroundImage: `url(${process.env.PUBLIC_URL + '/favicon.png'})`
    //     }}>
    // </div>